<template>
  <div class="dashboard-container">
    <el-form label-width="96px">
      <!--<el-form-item label="选择联赛">-->
        <!--<el-select v-model="matchId" filterable value-key="name" placeholder="请选择" >-->
          <!--<el-option-->
            <!--v-for="item in matchList"-->
            <!--:key="item.id"-->
            <!--:label="item.name"-->
            <!--:value="item.id">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <el-form-item label="比赛场次">
        <el-input v-model="game.seq" ></el-input>
      </el-form-item>
      <el-form-item label="主队">
        <el-input v-model="game.homeTeam" ></el-input>
      </el-form-item>
      <el-form-item label="客队">
        <el-input v-model="game.awayTeam" ></el-input>
      </el-form-item>
      <el-form-item label="比赛时间" >
        <el-date-picker
          v-model="game.beginDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="比赛监督" >
        <el-select v-model="office.supervisor" filterable placeholder="请选择" clearable>
          <el-option
            v-for="item in outRefereeList"
            :key="item.id"
            :label="item.trueName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="主裁1" >
            <el-select v-model="office.mainReferee1" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in inRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="主裁2" >
            <el-select v-model="office.mainReferee2" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in inRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="边裁1" >
            <el-select v-model="office.linesman1" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in inRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="边裁2" >
            <el-select v-model="office.linesman2" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in inRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="裁判监督" >
            <el-select v-model="office.refereeSupervisor" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in inRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="计时" >
            <el-select v-model="office.timer" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记录" >
            <el-select v-model="office.recorder" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="宣告" >
            <el-select v-model="office.announcer" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记罚" >
            <el-select v-model="office.refereeRecorder1" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="助理1" >
            <el-select v-model="office.assist1" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="助理2" >
            <el-select v-model="office.assist2" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" >
          <el-form-item label="助理3" >
            <el-select v-model="office.assist3" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" >
          <el-form-item label="记罚" >
            <el-select v-model="office.refereeRecorder2" filterable placeholder="请选择" clearable>
              <el-option
                v-for="item in outRefereeList"
                :key="item.id"
                :label="item.trueName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="refereeActionSave()">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
import { showMessage } from '@/utils'
import { getMatchList, adminAddOutGameOffice, AdminGetOutGame } from '@/api/match'
import { adminGetRefereeList } from '@/api/referee'
import {AdminUpdateOutGameOffice} from "@/api/game";
export default {
  name: 'StatsExportList',
  data() {
    return {
      match: {},
      matchId: null,
      gameId:null,
      game:{},
      matchList: [],
      routerParams: {},
      inRefereeList: [],
      outRefereeList: [],
      office: {
        supervisor: null,
        mainReferee1: null,
        mainReferee2: null,
        linesman1: null,
        linesman2: null,
        refereeSupervisor: null,
        timer: null,
        recorder: null,
        announcer: null,
        refereeRecorder1: null,
        refereeRecorder2: null,
        assist1: null,
        assist2: null,
        assist3: null
      }
    }
  },
  created() {
    this.matchId = this.$route.params.id
    this.gameId = this.$route.params.gameId
    this.getMatchList()
    this.getRefereeList()
    if(this.gameId) this.getOutGame()
  },
  computed: {
  },
  methods: {
    getMatchList() {
      const params = {
        pageSize: 9999,
        out: 2,
        status: 0
      }
      getMatchList(params).then((resolve) => {
        this.matchList = resolve.data.list
      })
    },
    getOutGame(){
      AdminGetOutGame({id: this.gameId}).then(resolve=>{
        const data = resolve && resolve.data
        this.office = data.office
        this.game = data.game
      })
    },
    getRefereeList() {
      let params = {
        pageNum: 1,
        pageSize: 9999,
        inField:1
      }
      adminGetRefereeList(params).then((resolve) => {
        this.inRefereeList = resolve.data.list
      })
      params = {
        pageNum: 1,
        pageSize: 9999,
        inField:0
      }
      adminGetRefereeList(params).then(resolve=>{
        this.outRefereeList = resolve.data.list
      })
    },
    refereeActionSave() {
      const params = {
        id: this.gameId,
        matchId: this.matchId,
        seq: this.game.seq,
        homeTeam: this.game.homeTeam,
        awayTeam: this.game.awayTeam,
        beginDate: this.game.beginDate? moment(this.beginDate).format('YYYY-MM-DDTHH:mm:ss+0800'):'',
        supervisor: this.office.supervisor,
        mainReferee1: this.office.mainReferee1,
        mainReferee2: this.office.mainReferee2,
        linesman1: this.office.linesman1,
        linesman2: this.office.linesman2,
        refereeSupervisor: this.office.refereeSupervisor,
        timer: this.office.timer,
        recorder: this.office.recorder,
        announcer: this.office.announcer,
        refereeRecorder1: this.office.refereeRecorder1,
        refereeRecorder2: this.office.refereeRecorder2,
        assist1: this.office.assist1,
        assist2: this.office.assist2,
        assist3: this.office.assist3
      }
      if(this.gameId) {
        AdminUpdateOutGameOffice(params).then(response => {
          const data = response.data
          if(data) {
            showMessage('success', '保存成功')
          }
        })
      } else {
        adminAddOutGameOffice(params).then(response => {
          const data = response.data
          if(data) {
            showMessage('success', '保存成功')
          }
        })
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
